<template>
  <div class="modal-wrapper fixed flex w-full sm:w-auto justify-center sm:justify-end mx-auto bottom-0 sm:right-0 mb-4 mr-4 z-130">
    <div
      :class="alertClass"
      role="alert"
      class="cursor-pointer m-2 px-2.5 py-1.5 rounded-md shadow-lg flex items-center space-x-2"
      @click="close"
    >
      <!-- eslint-disable-next-line vue/require-component-is -->
      <!-- <component :is="alertIcon" v-if="alertIcon" /> -->
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: true,
      default: 'success',
    },
  },
  computed: {
    alertClass() {
      const actionClasses = {
        default: 'bg-black-80 text-white',
        success: 'bg-o-green text-white',
        danger: 'bg-o-red text-white',
      };
      return actionClasses[this.variant];
    },
    alertIcon() {
      const actionIcon = {
        default: null,
        // success: IconNotifySuccess,
        // danger: IconNotifyError,
      };
      return actionIcon[this.variant];
    },
  },
};
</script>
